export default __webpack_public_path__ + "static/media/Group769.e989f71e.svg";